import { rfqQuoteDetailsHeaderStyles as styles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.printButton = {
    ...styles.printButton,
    css: css`
        span {
            color: ${getColor("secondary.main")};
        }
    `,
}
